<template>
  <div>
    <!--      <nav-bar :is-white-navbar="false" :navLight="true"></nav-bar>-->
    <!--    <GnbDownMenu :headers="headers" />-->

    <!-- 임시 메뉴 -->
    <!--    <b-container>-->
    <!--      <b-row>-->
    <!--        <b-col class="text-center mt-2">-->
    <!--          <b-link to="/">-->
    <!--            <img src="@/assets/images/main/top_logo.png" />-->
    <!--          </b-link>-->
    <!--        </b-col>-->
    <!--      </b-row>-->
    <!--      <b-nav align="center">-->
    <!--        <b-nav-item href="https://pinx-golf-0211.dalsoft.net/" target="_blank">핀크스 골프 클럽</b-nav-item>-->
    <!--        <b-nav-item href="https://pinx-podo-0211.dalsoft.net/" target="_blank">포도호텔</b-nav-item>-->
    <!--        <b-nav-item href="https://pinx-annex-0211.dalsoft.net/" target="_blank">디아넥스호텔</b-nav-item>-->
    <!--        <b-nav-item to="/p/HrAbout">인재채용</b-nav-item>-->
    <!--        <b-nav-item to="/p/Notice">공지사항</b-nav-item>-->
    <!--      </b-nav>-->
    <!--    </b-container>-->
    <Gnb :headers="headers" />
    <div class="contents">
      <router-view />
    </div>
    <div id="footer">
      <pinx-footer class="webFooter"></pinx-footer>
      <PinxFooterMobile class="mobileFooter"></PinxFooterMobile>
    </div>
  </div>
</template>

<script>
import PinxFooter from '@/components/PinxFooter';
import PinxFooterMobile from '@/components/PinxFooter_mobile';
import Gnb from '@/components/Gnb';

export default {
  components: {Gnb, PinxFooter, PinxFooterMobile},
  data() {
    return {
      isLang: true,
      headers: null,
      headers_ko: [
        {
          // topMenu: 'ABOUT',
          topMenu: '레스토랑',
          topMenuLink: '/p/Restaurant',
        },
        {
          // topMenu: 'ABOUT',
          topMenu: '핀크스 베이커리',
          topMenuLink: '/p/Bakery',
        },
        // {
        //   topMenu: 'RESERVATION',
        //   // topMenu: '골프코스',
        //   subMenu: [
        //     {
        //       link: '/p/RealtimebookingDining',
        //       text: '다이닝예약',
        //     },
        //   ],
        // },
        // {
        //   topMenu: 'Management',
        //   // topMenu: '골프코스',
        //   subMenu: [
        //     {
        //       link: '/p/Management/ManagementTrouble',
        //       text: '수선접수현황',
        //     },
        //   ],
        // },
      ],
      headers_en: [
        {
          // topMenu: 'ABOUT',
          topMenu: 'Restaurant',
          topMenuLink: '/p/Restaurant',
        },
        {
          // topMenu: 'ABOUT',
          topMenu: 'PINX Bakery',
          topMenuLink: '/p/Bakery',
        },
      ],
      headers_jp: [
        {
          // topMenu: 'ABOUT',
          topMenu: 'レストラン',
          topMenuLink: '/p/Restaurant',
        },
        {
          // topMenu: 'ABOUT',
          topMenu: 'PINX ベーカリー',
          topMenuLink: '/p/Bakery',
        },
      ],
    };
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.headers = this.headers_ko;
      } else if (newVal === 'en') {
        this.headers = this.headers_en;
      } else if (newVal === 'ja') {
        this.headers = this.headers_jp;
      } else {
        this.headers = this.headers_ko;
      }
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
};
</script>
<style lang="scss">
.contents {
  padding-bottom: 3rem;
}
.webFooter {
  display: block;
}
.mobileFooter {
  display: none;
}
@media (max-width: 992px) {
  .webFooter {
    display: none;
  }
  .mobileFooter {
    display: block;
  }
}
</style>
